import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { authAPI } from '../api';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    authAPI.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ textAlign:'center' }}>
        {status === 'loading' && <p style={{ color:'var(--text2)' }}>Verification...</p>}
        {status === 'success' && (
          <div>
            <div style={{ fontSize:64 }}>✅</div>
            <h2 style={{ fontFamily:'Syne,sans-serif', margin:'16px 0' }}>Email verifie !</h2>
            <Link to="/dashboard" style={{ color:'var(--accent)' }}>Aller au tableau de bord</Link>
          </div>
        )}
        {status === 'error' && (
          <div>
            <div style={{ fontSize:64 }}>❌</div>
            <h2 style={{ fontFamily:'Syne,sans-serif', margin:'16px 0' }}>Lien invalide ou expire</h2>
            <Link to="/login" style={{ color:'var(--accent)' }}>Se connecter</Link>
          </div>
        )}
      </div>
    </div>
  );
}